import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DebounceModule } from 'src/app/@core/directives/debounce/debounce.module';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosConfirmationComponent } from './pos-confirmation.component';



@NgModule({
  declarations: [PosConfirmationComponent],
  imports: [
    ModalModule.forRoot(),
    DebounceModule
  ],
  providers: [PosConfirmationService],
  exports: [PosConfirmationComponent]
})
export class PosConfirmationModule { }
